import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';
import LocalizationMenu from './LocalizationMenu.js';
import MainMenu from './MainMenu/index.js';
import Search from '../Search/index.js';
import AccordionItem from '../../Sections/Accordion/AccordionItem.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    refs: ['ShopBtn', 'topheader', 'shopbar', 'shopMenuZone', 'announcementBar'],
    components: {
      MainMenu,
      LocalizationMenu,
      Search,
      AccordionItem,
    },
  };

  /**
   *
   */
  mounted() {
    this.setVars();
  }

  /**
   *
   */
  setVars() {
    const announcementBarHeight = this.$refs.announcementBar?.offsetHeight ?? 0;
    const shopbarHeight = this.$refs.shopbar?.offsetHeight ?? 0;
    const headerHeight = this.$el.offsetHeight ?? 0;

    document.documentElement.style.setProperty(
      '--announcement-height',
      `${announcementBarHeight}px`,
    );
    document.documentElement.style.setProperty('--shopbar-height', `${shopbarHeight}px`);
    document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
  }

  /**
   * Recompute offsets once the secondary announcement message has finished
   * animating open, since toggling it changes the header's rendered height on mobile.
   */
  onAccordionItemOpen() {
    setTimeout(() => this.setVars(), 300);
  }

  /**
   * Recompute offsets once the secondary announcement message has finished
   * animating closed.
   */
  onAccordionItemClose() {
    setTimeout(() => this.setVars(), 300);
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    this.isSticky = y >= 3;

    toggleClass(document.documentElement, 'is-on-top', isOnTop);
    toggleClass(document.documentElement, 'is-sticky', this.isSticky);

    if (direction.y === 'NONE') {
      return;
    }

    if (!window.matchMedia('(min-width: 64rem)').matches) {
      return;
    }

    if (this.isSticky && !this.isHoveringShopMenu) {
      this.hideShopBar();
    }

    if (isOnTop) {
      this.showShopBar();
    }

    // toggleClass(document.documentElement, 'is-scrolling-down', direction.y === 'DOWN');
    // toggleClass(document.documentElement, 'is-scrolling-up', direction.y === 'UP');
  }

  /**
   * Toggle the shopbar like an accordion on mobile.
   * @param {object} payload
   * @param {number} payload.index
   */
  onShopBtnClick({ index }) {
    if (window.matchMedia('(min-width: 64rem)').matches) {
      return;
    }

    const shopbars = [this.$refs.shopbar].flat();
    const target = shopbars[index] ?? shopbars[0];
    target?.classList.toggle('is-closed');
  }

  /**
   *
   */
  onShopMenuZoneMouseenter() {
    this.isHoveringShopMenu = true;
    if (this.isSticky) {
      this.showShopBar();
    }
  }

  /**
   *
   */
  onShopMenuZoneMouseleave() {
    this.isHoveringShopMenu = false;
  }

  /**
   *
   */
  showShopBar() {
    this.$refs.shopbar.style.opacity = '1';
    this.$refs.shopbar.style.pointerEvents = 'auto';
  }

  /**
   *
   */
  hideShopBar() {
    this.$refs.shopbar.style.opacity = '0';
    this.$refs.shopbar.style.pointerEvents = 'none';
  }

  /**
   *
   */
  onMainMenuChange() {
    if (this.searchIsOpen) {
      this.$children.Search[0].close();
    }
  }

  /**
   * Check if search is open
   * @returns {boolean}
   */
  get searchIsOpen() {
    return document.documentElement.classList.contains('search-is-open');
  }
}
